import React from 'react'
import PropTypes from 'prop-types'
import ServiceRow from './ServiceRow'
import { EXETEL_URL, mapServiceTypeToTitle } from '../constants'
import UsageRow from './UsageRow'
import CustomLink from './CustomLink'
import { useMedia } from 'react-use'
import useReadableDate from '../hooks/useReadableDate'

const ServiceRowSpeedBoost = (props) => {
    const isMobile = useMedia('(max-width: 992px)')
    const currentBoostEnds = useReadableDate(props.item.currentBoostEnds)

    const goToLink = event => {
        event.preventDefault()
        event.stopPropagation()
        const win = window.open(`${EXETEL_URL}/broadband/nbn/home-secure`, '_blank', 'noreferrer,noopener')
        if (win !== null) {
            win.focus()
        }
    }

    const LearnMore = <a href='#' onClick={goToLink} className='color-grey underline'>Learn more</a>

    return (
        <ServiceRow
            icon={`/images/${props.item.boostStatus === 'Active' ? 'On.svg' : 'Off.svg'}`}
            title={mapServiceTypeToTitle[props.item.type]}
            preTitle='Push button. Boost speed.'
            subTitle={LearnMore}
            url={`/my-services/speed-boost/${props.item.broadbandServiceId}`}
            isSubService
        >
            {!isMobile
                ? <React.Fragment>
                    {props.item.isEnabled
                        ? <React.Fragment>
                            <UsageRow
                                title='Current boost speed'
                                isUnlimitedUsage
                                showUnlimitedUsage
                                summaryText={props.item.boostSpeed}
                            />
                            <UsageRow
                                title='Current boost ends'
                                isUnlimitedUsage
                                showUnlimitedUsage
                                summaryText={currentBoostEnds}
                            />
                        </React.Fragment>
                        : <React.Fragment>
                            <UsageRow
                                title='Boost status'
                                isUnlimitedUsage
                                showUnlimitedUsage
                                summaryText={<CustomLink to={`/my-services/speed-boost/${props.item.broadbandServiceId}`} className='color-grey'>Turn on boost</CustomLink>}
                            />
                            <UsageRow
                                title='Available boost speed'
                                isUnlimitedUsage
                                showUnlimitedUsage
                                summaryText={props.item.boostSpeed}
                            />
                        </React.Fragment>}
                    <UsageRow
                        title='My Boost Bank days'
                        isUnlimitedUsage
                        showUnlimitedUsage
                        summaryText={`${props.item.boostBankDays} (30 days max)`}
                        isLastItem
                    />
                </React.Fragment>
                : ''}
        </ServiceRow>
    )
}

ServiceRowSpeedBoost.propTypes = {
    item: PropTypes.shape({
        boostBankDays: PropTypes.number,
        boostBankMax: PropTypes.number,
        boostDayCost: PropTypes.string,
        boostMonthDays: PropTypes.number,
        boostMonthMax: PropTypes.number,
        boostProgress: PropTypes.number,
        boostSpeed: PropTypes.string,
        boostStatus: PropTypes.string,
        broadbandServiceId: PropTypes.number,
        currentBoostEnds: PropTypes.string,
        endDate: PropTypes.any,
        endTime: PropTypes.string,
        scheduleEnabled: PropTypes.bool,
        scheduleEndDate: PropTypes.any,
        scheduleStartDate: PropTypes.any,
        scheduledDays: PropTypes.number,
        scheduledStartTime: PropTypes.any,
        startDate: PropTypes.string,
        startTime: PropTypes.string,
        type: PropTypes.string
    }).isRequired
}

export default ServiceRowSpeedBoost



// WEBPACK FOOTER //
// ./resources/js/components/ServiceRowSpeedBoost.js